import { render, staticRenderFns } from "./ApplicationReceivedItem.vue?vue&type=template&id=0fbaa384&scoped=true"
import script from "./ApplicationReceivedItem.vue?vue&type=script&lang=js"
export * from "./ApplicationReceivedItem.vue?vue&type=script&lang=js"
import style0 from "./ApplicationReceivedItem.vue?vue&type=style&index=0&id=0fbaa384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbaa384",
  null
  
)

export default component.exports